var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoenixarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 35,
    viewBox: "0 0 54 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 17.4997H21.7053L0 0.5L36.3445 5.40137L54 17.4997Z",
    fill: "url(#paint0_linear_506_18925)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17.5003H21.6787L0 34.5L36.3445 29.5986L54 17.5003Z",
    fill: "url(#paint1_linear_506_18925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_18925",
    x1: -7.00016,
    y1: 17.5,
    x2: 59.435,
    y2: 23.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#D21D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#E24231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_18925",
    x1: -7.97628,
    y1: 24.3155,
    x2: 52.9314,
    y2: 8.84449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213769,
    stopColor: "#D21D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401437,
    stopColor: "#E24231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoenixarr);
export default __webpack_public_path__ + "static/media/phoenixarr.5d67ea792421ede7550ac4b555863a85.svg";
export { ForwardRef as ReactComponent };